// import * as FileSaver from 'file-saver';
// import * as XLSX from 'xlsx';

// export function exportToExcel(csvData, fileName) {
//     const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
//     const fileExtension = '.xlsx';

//     const ws = XLSX.utils.json_to_sheet(csvData);
//     const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
//     const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
//     const data = new Blob([excelBuffer], { type: fileType });
//     FileSaver.saveAs(data, fileName + fileExtension);
// }

export const isObject = (stuff) => (
    typeof stuff === 'object' &&
    !Array.isArray(stuff) &&
    stuff !== null
);

export const openLink = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', '');
    document.body.appendChild(link);
    link.click();
};